"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoImage = void 0;
var NoImage_1 = require("./NoImage");
Object.defineProperty(exports, "NoImage", { enumerable: true, get: function () { return NoImage_1.NoImage; } });
